import { appConfig as $config } from '../../app.config';
import { UI } from '../../modules/UI';
import { App } from '../../modules/App';

const statuses = ['Ordered', 'Paid', 'Fulfilled', 'Shipped', 'PendingPayment', 'Canceled'];
const orderTypes = ['Production', 'Sampling', 'Testing'];
const statusesWhenButtonActive = [0, 2];

const isSubmittableStatus = (status) => {
  return statusesWhenButtonActive.includes(status);
};

const serviceProvidersRenderer = (data, type, full) => {
  return `<span bind-var-idx="DT.ordersGridData.findIndex(item => item.id == '${full.id}')">
            <select id="serviceProviderDropdown-${full.id}" class="form-control service-provider-select" data-lineiteminstoreid='${full.id}'
              bind-statement-disabled="thisElem.disabled = #DT.selectedStore == 'Archive' || !#DT.ordersGridData[#idx].controlActive"
              bind-event-change="
                if(thisElem.value === '') {
                  #DT.ordersGridData[#idx].checkDisable = true;
                } else {
                  #DT.ordersGridData[#idx].checkDisable = false;
                }
                #DT.ordersGridData[#idx].lookupServiceProviders.forEach(item=>{
                  if(thisElem.value===''){
                    item.isSelected=false;
                    item.facilities.forEach(item=>item.isSelected=false);
                    #DT.ordersGridData[#idx].selectedFacilities = null;
                  } else {
                    if(thisElem.value===item.id){
                      item.isSelected=true;
                      #DT.ordersGridData[#idx].selectedFacilities = item.facilities;
                    } else {
                      item.isSelected=false;
                    }
                  }
                });">
              <option value="">${$Lang.storelineitems.notAssigned}</option>
              <option 
                  bind-repeater-i="#DT.ordersGridData[#idx].lookupServiceProviders.length" 
                  bind-var-item="#DT.ordersGridData[#idx].lookupServiceProviders[#i]"
                  bind-statement-selected="thisElem.selected = #item.isSelected"
                  bind-statement-1="$(thisElem).text(#item.name).prop('value', #item.id)"></option>
          </select>
        </span>`;
};

const orderTypeRender = (data, type, full) => {
  let options = '';
  let selectedOrderType = full.selected ? full.selected.orderType : full.orderInfo.orderType;

  if (!selectedOrderType) {
    selectedOrderType = orderTypes[0]; // By default Production
  }

  orderTypes.forEach((sp) => {
    const selected = sp === selectedOrderType ? 'selected' : '';
    return (options += '<option ' + selected + ' value="' + sp + '">' + sp + '</option>');
  });

  const selectedStore = App.pageData('selectedStore');
  const disabled = selectedStore === 'Archive' || !isSubmittableStatus(full.productionStatus) ? 'disabled' : '';

  return `<select
            class="form-control order-type-select"
            style="width:175px;"
            data-lineiteminstoreid='${full.id}'
            id="orderTypeDropdown-${full.id}"
            ${disabled}>
              ${options}
          </select>`;
};

const printMethodRender = (data, type, full) => {
  const selectedStore = App.pageData('selectedStore');
  const selected = full.selected ? full.selected.printMethod : full.orderInfo.printMethod;
  const disabled = selectedStore === 'Archive' || !isSubmittableStatus(full.productionStatus) ? 'disabled' : '';
  return `<select class="form-control print-method-select" ${disabled} data-lineiteminstoreid="${
    full.id
  }" style="width:100px;">
            ${$config.printMethods.map((pm) => {
              return `<option ${selected == pm.id ? 'selected' : ''} value="${pm.id}">${pm.name}</option>`;
            })}
          </select>`;
};

const productionStatusStyle = (data) => {
  let style = 'warning';
  switch (data) {
    case 5:
      style = 'success';
      break;
    case 2:
      style = 'danger';
      break;
    case 3:
    case 4:
    case 6:
    case 1:
      style = 'success';
      break;
  }
  return style;
};

export const Columns = {
  orders: [
    {
      data: '',
      orderable: false,
      sortable: false,
      searchable: false,
      width: 20,
      className: 'text-center',
      render: (data, type, full, meta) => {
        const idx = meta.row;
        return `<label bind-var-item="#DT.ordersGridData[${idx}]" class="kt-checkbox kt-checkbox--danger mb-4 mt-1 p-0 pr-3">
                  <input type="checkbox" data-id="${full.id}"
                    bind-statement-checked="thisElem.checked = #item.selected"
                    class="kt-checkable">
                  <span></span>
                </label>`;
      }
    },
    {
      title: $Lang.storelineitems.AccountnameColumn,
      data: null,
      render: (data, type, full) => {
        return `${full.account?.accountName}<br>${full.licensedProduct?.masterProductData?.brand}`;
      }
    },
    {
      title: $Lang.storelineitems.OrderDateColumn,
      data: 'createdDate',
      orderable: true,
      sortable: true,
      searchable: false,
      className: 'text-nowrap',
      render: (data, type, full) => {
        return moment(data).format('MMM DD, YYYY <br>HH:mm');
      }
    },
    {
      title: $Lang.storelineitems.PrintMethodColumn,
      data: null,
      orderable: false,
      sortable: false,
      searchable: false,
      responsivePriority: 3,
      render: printMethodRender
    },
    {
      title: $Lang.storelineitems.OrderTypeColumn,
      data: '',
      orderable: false,
      sortable: false,
      searchable: false,
      responsivePriority: 2,
      render: orderTypeRender
    },
    {
      title: $Lang.storelineitems.OrderNumberColumn,
      data: 'orderInfo.orderNumber',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.storelineitems.ProductionOrderNumberColumn,
      data: 'orderInfo.productionOrderNumber',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.storelineitems.SKUColumn,
      data: 'sku',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.storelineitems.ServiceProviderColumn,
      data: '',
      orderable: false,
      sortable: false,
      searchable: false,
      responsivePriority: 1,
      render: serviceProvidersRenderer
    },
    {
      title: $Lang.storelineitems.ProductionStatusColumn,
      data: 'productionStatusText',
      orderable: true,
      sortable: true,
      searchable: false,
      render: (data, type, full) => {
        return `<div class="text-nowrap">
        <span productionStatus='${full.productionStatus}' id="productionStatusText-${
          full.id
        }" class="bbw-badge kt-badge kt-badge--outline kt-badge--${productionStatusStyle(
          full.productionStatus
        )} text-nowrap">${data}</span>
          ${full.productionStatusMessage ?
          `<i class="js-action-production-error-dialog fal fa-question-circle fa-lg text-primary ml-10 cursor-pointer" 
            data-id="${full.id}"/>` : ''}
        </div>`;
      }
    },
    {
      title: $Lang.storelineitems.StoreStatusColumn,
      data: 'brandbowStatus',
      orderable: true,
      sortable: true,
      searchable: false,
      render: (data, type, full) => {
        return `<span class="bbw-badge kt-badge kt-badge--outline kt-badge--${data === 5 ? 'danger' : 'success'}">${
          statuses[data]
        }</span>`;
      }
    },
    {
      title: $Lang.storelineitems.ProductNameColumn,
      data: 'title',
      orderable: false,
      sortable: false,
      searchable: false,
      render: (data, type, full) => {
        return `
          <div class="table-thumbnail-wrapper">
              ${UI.thumbnail(full.productImage)}
              <a href="javascript:" data-id="${full.licensedProduct.id}" data-accountid="${full.accountId}" 
              class="js-action-productinfo-dialog table-thumbnail-description">${full.licensedProduct.title}</a>
          </div>
          `;
      }
    },
    {
      title: $Lang.storelineitems.ChannelSignName,
      data: 'orderInfo.channelSignName',
      orderable: false,
      sortable: false,
      searchable: false,
      className: ''
    },
    {
      title: $Lang.storelineitems.SelfLogistics,
      data: 'storeDetail.SelfLogistics',
      orderable: false,
      sortable: false,
      searchable: false,
      render: (data) => data ? 'yes' : 'no'
    },
    {
      orderable: false,
      data: null,
      sortable: false,
      className: '',
      responsivePriority: 0,
      render: (data, type, full) => {
        return (
          '<a href="javascript:" data-id="' +
          full.id +
          '" class="details-control"><i class="fas fa-caret-circle-down fa-lg"></i></a>'
        );
      }
    }
  ]
};
